/* tslint:disable */
/* This file was generated by @citrite/translate. Manual changes will be lost. */
import { Language } from '@citrite/translate';
export type locale = 'de' | 'en' | 'es' | 'fr' | 'it' | 'ja' | 'nl' | 'pt-BR';
export const languages: Language[] = [
  {
    "key": "de",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "von {{count}}",
          "Page": "Seite",
          "PageOfCount": "{{current}} von {{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "DownloadError": "Something went wrong",
        "DownloadErrorDescription": "There was an error downloading the file. Please try again later.",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleDownloadSupported": "Download not supported",
        "MultipleDownloadSupportedDescription": "Multiple files cannot be downloaded because they cannot be watermarked. You can download files one at a time",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      },
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "KB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      }
    }
  },
  {
    "key": "en",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "of {{count}}",
          "Page": "Page",
          "PageOfCount": "{{current}} of {{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "DownloadError": "Something went wrong",
        "DownloadErrorDescription": "There was an error downloading the file. Please try again later.",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleDownloadSupported": "Download not supported",
        "MultipleDownloadSupportedDescription": "Multiple files cannot be downloaded because they cannot be watermarked. You can download files one at a time",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      },
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "KB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      }
    }
  },
  {
    "key": "es",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "de {{count}}",
          "Page": "Página",
          "PageOfCount": "{{current}} de {{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "DownloadError": "Something went wrong",
        "DownloadErrorDescription": "There was an error downloading the file. Please try again later.",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleDownloadSupported": "Download not supported",
        "MultipleDownloadSupportedDescription": "Multiple files cannot be downloaded because they cannot be watermarked. You can download files one at a time",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      },
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "KB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      }
    }
  },
  {
    "key": "fr",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "sur {{count}}",
          "Page": "Page",
          "PageOfCount": "{{current}} sur {{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "DownloadError": "Something went wrong",
        "DownloadErrorDescription": "There was an error downloading the file. Please try again later.",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleDownloadSupported": "Download not supported",
        "MultipleDownloadSupportedDescription": "Multiple files cannot be downloaded because they cannot be watermarked. You can download files one at a time",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      },
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "KB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      }
    }
  },
  {
    "key": "it",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "di {{count}}",
          "Page": "Pagina",
          "PageOfCount": "{{current}} di {{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "DownloadError": "Something went wrong",
        "DownloadErrorDescription": "There was an error downloading the file. Please try again later.",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleDownloadSupported": "Download not supported",
        "MultipleDownloadSupportedDescription": "Multiple files cannot be downloaded because they cannot be watermarked. You can download files one at a time",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      },
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "KB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      }
    }
  },
  {
    "key": "ja",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "/{{count}}",
          "Page": "ページ",
          "PageOfCount": "{{current}}/{{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "DownloadError": "Something went wrong",
        "DownloadErrorDescription": "There was an error downloading the file. Please try again later.",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleDownloadSupported": "Download not supported",
        "MultipleDownloadSupportedDescription": "Multiple files cannot be downloaded because they cannot be watermarked. You can download files one at a time",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      },
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "KB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      }
    }
  },
  {
    "key": "nl",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "van {{count}}",
          "Page": "Pagina",
          "PageOfCount": "{{current}} van {{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "DownloadError": "Something went wrong",
        "DownloadErrorDescription": "There was an error downloading the file. Please try again later.",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleDownloadSupported": "Download not supported",
        "MultipleDownloadSupportedDescription": "Multiple files cannot be downloaded because they cannot be watermarked. You can download files one at a time",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      },
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "KB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      }
    }
  },
  {
    "key": "pt-BR",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "de {{count}}",
          "Page": "Página",
          "PageOfCount": "{{current}} de {{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "DownloadError": "Something went wrong",
        "DownloadErrorDescription": "There was an error downloading the file. Please try again later.",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleDownloadSupported": "Download not supported",
        "MultipleDownloadSupportedDescription": "Multiple files cannot be downloaded because they cannot be watermarked. You can download files one at a time",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      },
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "KB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      }
    }
  }
];